<template>
  <el-dialog
    v-if="isVisible"
    class="promocode-or-bundle-dialog order-test"
    v-model="isVisible"
    title="Promo Code and Bundle Cannot Be Combined"
    append-to-body
    @close="close"
  >
  <div>
    <div class="promo-code-or-bundle-dialog-body-text-container">
      <span class="promocode-or-bundle-text">
        This promo code cannot be combined with your selected bundle. Below are the prices for each option:
      </span>
    </div>
    <div class="flex justify-center align-center promo-code-or-bundle-dialog-tag-and-button">
      <BundleOrPromoTagAndButton
        name="Bundle Price"
        :price="priceWithoutBreakdown"
        chooseBundleOrPromo="Keep Bundle Discount"
        :type="priceWithoutBreakdown > priceWithBreakdown ? 'higher' : 'lower'"
        @buttonClick="userChoosesBundle"
      />
      <div class="vertical-dashed-line"></div>
      <BundleOrPromoTagAndButton
        name="Promo Price"
        :price="priceWithBreakdown"
        chooseBundleOrPromo="Apply Promo Code"
        :type="priceWithoutBreakdown > priceWithBreakdown ? 'lower' : 'higher'"
        @buttonClick="userChoosesPromoCode"
      />
    </div>
  </div>
  </el-dialog>
</template>

<script>
import BundleOrPromoTagAndButton from "./BundleOrPromoTagAndButton.vue";

export default {
  name: "PromoCodeOrBundleDialog",

  components: {
    BundleOrPromoTagAndButton,
  },
  
  props: {
    isPromoCodeOrBundleDialogVisible: {
      type: Boolean,
      default: false,
    },
    priceWithBreakdown: {
      type: Number,
      default: 0,
    },
    priceWithoutBreakdown: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      isVisible: false,
    }
  },

  watch: {
    isPromoCodeOrBundleDialogVisible(newVal) {
      this.isVisible = newVal;
    },
  },

  methods: {
    close() {
      this.$emit("close");
    },
    userChoosesBundle() {
      this.$emit("user-chooses-bundle");
    },
    userChoosesPromoCode() {
      this.$emit("user-chooses-promo-code");
    },
  },

}
</script>

<style scoped>
.promo-code-or-bundle-dialog-body-text-container {
    display: flex;
    padding-bottom: 22px;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 30px;
    align-self: stretch;
}

.promocode-or-bundle-text {
    color: var(--Gray-100, #161616);
    font-size: 16px;
    font-weight: 500;
    line-height: normal;
    text-align: left;
    word-break: keep-all;
}

.vertical-dashed-line{
    height: 140px;
    border-left: 1px dashed #C4C4C4;
    margin-left: 11px;
    margin-right: 11px;
    margin-top: 27.5px;
}

.promo-code-or-bundle-dialog-tag-and-button {
    padding-bottom: 37px;
}
</style>
